import { motion } from "framer-motion";

/**
 * Reveal — lightweight scroll-in animation wrapper.
 * Fires as soon as the element enters the viewport (generous margin so it
 * never feels "late"), animates once, and supports a small stagger via delay.
 */
const DIRECTIONS = {
  up: { y: 36, x: 0 },
  down: { y: -36, x: 0 },
  left: { x: 48, y: 0 },
  right: { x: -48, y: 0 },
  none: { x: 0, y: 0 },
};

export default function Reveal({
  children,
  direction = "up",
  delay = 0,
  duration = 0.7,
  className = "",
  once = true,
  amount = 0.25,
}) {
  const offset = DIRECTIONS[direction] || DIRECTIONS.up;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount, margin: "0px 0px -10% 0px" }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
